import { createValidationObject, whiteSpaceCheck } from "../yoello-lib/modules/dynamicForms/ValidationUtils";
import { PostCodeValidator } from "../yoello-lib/modules/utils/PostCodeValidator";

const vatRegex = /^.{5,25}$/;
const patterMsg = "errors.formerrors.pattern";
const checkKeys = ["owner_phone", "owner_email", "venue_name", "location_name", "address_country", "time_zone_id", "language_id"]

export function detailsValidationResolver(data: any, isSquare: boolean) {
    const address_postcode = data.address_postcode;
    const address_country = data.address_country;
    const vat_number = data.vat_number;
    const exo_number = data.exo_number;
    const validationOutput: Record<string, any> = {};
    whiteSpaceCheck(checkKeys, data, validationOutput);

    const validation = PostCodeValidator(address_postcode, address_country);
    if (!isSquare && !validation) {
        validationOutput['address_postcode'] = createValidationObject("address_postcode", "forms.details.postCodeError");
    }
    if (vat_number && !vatRegex.test(vat_number)) {
        validationOutput['vat_number'] = createValidationObject("vat_number", patterMsg);
    }
    if (exo_number && !vatRegex.test(exo_number)) {
        validationOutput['exo_number'] = createValidationObject("exo_number", patterMsg);
    }
    const hasErrors = !!Object.keys(validationOutput).length;

    return {
        values: hasErrors ? {} : data,
        errors: hasErrors ? validationOutput : {}
    }
}
